<template>
  <div>
    <!-- Overlay -->
    <div class="fab-overlay" v-show="isOpen" @click="toggleMenu"></div>

    <!-- Botón flotante -->
    <button class="fab-btn" @click="toggleMenu">
      <i :class="isOpen ? 'bi bi-x-lg' : 'bi-plus-lg'"></i>
    </button>
    <!-- Menú -->
    <div class="fab" :class="{ show: isOpen }">
      <div
        v-for="(item, index) in filteredMenu"
        class="fab-item"
        :key="item.label"
        :data-tooltip="item.label"
        :class="getTypeClass(item)"
        :style="getItemStyle(index, item)"
        @click="handleItemClick(item)" >
        <i :class="item.icon"></i>
      </div>
    </div>
  </div>
</template>

<style scoped>
  @import "../../assets/css/floating-action-button.css";
</style>

<script>
  export default {
    name: "FloatingActionButton",
    props: {
      menuItems: {
        type: Array,
        required: true
      },
      userRoles: {
        type: Array,
        default: () => []
      },
      userPermissions: {
        type: Array,
        default: () => []
      },
      context: {
        type: Object,
        default: () => ({})
      }
    },
    data() {
      return {
        isOpen: false
      }
    },
    computed: {
      filteredMenu() {
        return this.menuItems.filter(item => {
          // Validación por roles
          const roleValid = !item.roles || item.roles.length === 0 || item.roles.some(r => this.userRoles.includes(r))

          // Validación por permisos
          const permValid = !item.permissions || item.permissions.length === 0 || item.permissions.every(p => this.userPermissions.includes(p))

          return roleValid && permValid
        })
      }
    },
    methods: {
      toggleMenu() {
        this.isOpen = !this.isOpen
      },
      handleItemClick(item) {
        const route = this.resolveRoute(item.route);

        // Navegación
        if (route) {
          this.$router.push(route)
        }

        // Acción personalizada
        if (item.action) {
          item.action(item)
        }

        // Cerrar menú
        this.isOpen = false
      },
      // Animación en cascada
      getItemStyle(index, item) {
        const total = this.filteredMenu.length;
        const delay = (total - index - 1) * 0.08;

        const style = {
          transitionDelay: this.isOpen ? `${delay}s` : '0s'
        };

        if (item.color) {
          style.background = item.color;
        }

        return style;
      },
      // Clase por tipo (usa sistema global)
      getTypeClass(item) {
        if (item.color) return null;
        if (item.type) return `bg-${item.type}`;
        return "bg-primary";
      },
      resolveRoute(route) {
        if (!route) return null;

        // 1. Si es función → ejecuta
        if (typeof route === 'function') {
          return route(this.context);
        }

        // 2. Si es string con variables tipo ${}
        if (typeof route === 'string') {
          return route.replace(/\$\{(.*?)\}/g, (_, key) => {
            return this.context[key.trim()] || '';
          });
        }

        return route;
      }
    }
  }
</script>
